import { persist, createJSONStorage } from 'zustand/middleware';
import { _initialState } from './_initialState';
import {
  updateBundles,
} from '../design/actions';

// CODE SMELL: Vehicle Storage specific imports (copy pasta carbs)
import selectVehicleStorageProduct from './actions/selectVehicleStorageProduct';
import resetSelectedVehicleStorageProduct from './actions/resetSelectedVehicleStorageProduct';
import handleVehicleStorageDragEvent from './actions/handleVehicleStorageDragEvent';
import { createActions } from './actions/index';
import updateVehicleVisualizer from './actions/updateVehicleVisualizer';
import { removeNonVisualizedProduct } from './actions/removeNonVisualizedProduct';
import { updateNonVisualizedQty } from './actions/updateNonVisualizedQty';
import { addNonVisualizedProduct } from './actions/addNonVisualizedProduct';
import { selectVehicleStorageVisualizerStack } from './actions/selectVehicleStorageVisualizerStack';
import { removeStackFromDesign } from './actions/removeStackFromDesign';

export const vehicleStorageStore = persist(
  (set, get) => ({
    ..._initialState,
    ...createActions(set, get),
    updateVehicleVisualizer: (data) => updateVehicleVisualizer(set, get, data),
    updateBundles: (data) => updateBundles(set, get, data),
    select: (
      visualizerMetaDataAndChoiceId
    ) => selectVehicleStorageProduct(
      set,
      get,
      visualizerMetaDataAndChoiceId
    ),
    selectVehicleStorageVisualizerStack: (stackId) => selectVehicleStorageVisualizerStack(set, get, stackId),
    resetSelected: () => resetSelectedVehicleStorageProduct(set, get),
    resetSelectedDesign: () => set({
      designs: {
        ...get().designs,
        [get().selectedDesignId]: {
          ...get().designs[get().selectedDesignId],
          Stacks: [],
          Products: [],
          Cart: []
        }
      },
    }),
    addNonVisualizedProduct: (
      updatedAccessories
    ) => addNonVisualizedProduct(set, get, updatedAccessories),
    removeNonVisualizedProduct: (sku) => removeNonVisualizedProduct(set, get, sku),
    updateNonVisualizedQty: (sku, qty) => updateNonVisualizedQty(set, get, sku, qty),
    removeStackFromDesign: (stackId) => removeStackFromDesign(set, get, stackId),
    handleDragEvent: (
      isDragging,
      isVisualizerDrag,
    ) => handleVehicleStorageDragEvent(set, get, isDragging, isVisualizerDrag),
  }),
  {
    name: 'design-session-storage-vehicle',
    version: 0,
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({
      designs: state.designs,
      designIds: state.designIds,
      selectedDesignId: state.selectedDesignId,
    })
  }
);
